module.exports = __webpack_public_path__ + "media/images/steps/svg/businessman-6e84271e705eb56e9d8ab7dfaa572059.svg";